import 'amplitude-js';

export class Amplitude {
	static init() {
		try {
			amplitude.init('c0e86613fd60aee28d51eab6cc3f15f9', null, {
				includeUtm: true,
				includeReferrer: true
			});
		}
		catch (e) { }
	}

	static identify() {
		try {
			new amplitude.Identify();

			const userId = $('#user-id').val();
			if (userId != null) {
				amplitude.setUserId(userId as string);
				amplitude.setUserProperties({
					'Name': $('#user-name').val(),
					'Email': $('#user-email').val(),
					'Role': $('#user-role').val(),
				});
			};
		}
		catch (e) { }
	}

	static logEvent(event: string, data: Object = {}) {
		const scope = {
			'Provider': $('#provider-name').val()
		}

		Object.assign(data, scope);

		try {
			//console.log(event);
			//console.log(data);

			amplitude.logEvent(event, data);
		}
		catch (e) { }
	}
}
